import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getOutboundDataSyncPlanner = createApi("OutboundDataSyncPlanner","GET");

const OutboundDataSyncPlanner = createSlice({
  name: 'OutboundDataSyncPlanner',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOutboundDataSyncPlanner.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOutboundDataSyncPlanner.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getOutboundDataSyncPlanner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default OutboundDataSyncPlanner.reducer;